import $ from 'jquery'
import spinner from 'templates/spinner.pug'

import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'

const DEFAULTS = {
  showClass: 'show-spinner'
}

class Spinner extends BaseComponent {
  static componentName = 'spinner'

  static emitterEvents = {
    'spinner:show': 'show',
    'spinner:hide': 'hide'
  }

  constructor (element, options = {}) {
    super(element)

    this.options = $.extend({}, DEFAULTS, options)
  }

  init () {
    this.appendSpinner()
  }

  show () {
    this.$element.addClass(this.options.showClass)
  }

  hide () {
    this.$element.removeClass(this.options.showClass)
  }

  appendSpinner () {
    this.$element.append(spinner())
  }
}

export default ($el) => new Spinner($el).init()

export { Spinner as Component }
